import Spinner from '@core/components/spinner/Spinner';
import { useQuery } from 'react-query';
import { GetUserDashboard } from 'services/core';

import { NextSeo } from 'next-seo';
import { getUserDashboardSeoProps } from 'router/seoprops';

import DashboardMenuDesktop from '@core/components/dashboardMenuDesktop/DashboardMenuDesktop';
import UserDashboardInfo from 'components/pages/userdashboard/userdashboardinfo/UserDashboardInfo';

import classes from './index.module.scss';

const index = () => {
    const { data, isLoading } = useQuery('dashboard-info', GetUserDashboard);

    const seoProps = getUserDashboardSeoProps();
    return (
        <>
            <NextSeo {...seoProps} />
            {isLoading ? (
                <div className={classes['loading']}>
                    <Spinner />
                </div>
            ) : (
                <UserDashboardInfo data={data.data} />
            )}
        </>
    );
};

export default index;